import { asyncTypes } from 'store/_helpers';

const TYPES = {
  ...asyncTypes('GET_INDEXES'),
  ...asyncTypes('UPDATE_INDEX'),
  ...asyncTypes('CREATE_INDEX'),
  ...asyncTypes('ARCHIVE_INDEX'),
  ...asyncTypes('GET_INDEX_VALUES'),
  ...asyncTypes('UPDATE_INDEX_VALUE'),
  ...asyncTypes('GET_INDEXES_VALUES'),
  ...asyncTypes('GET_INDEX_VISIBILITY'),
  ...asyncTypes('UPDATE_INDEX_VISIBILITY'),
  ...asyncTypes('DELETE_INDEX_VALUE'),
  SET_BULK_VALUES: 'SET_BULK_VALUES'
};

export default TYPES;
